import { browser } from '$app/environment';
import {
    PUBLIC_SUPABASE_ANON_KEY,
    PUBLIC_SUPABASE_URL
} from '$env/static/public';
import {
    get_teacher_allowed_product_ids,
    get_user_entitlements,
    patch_purchased_bundles,
    patch_purchased_courses,
    patch_purchased_worksheets
} from '$lib/utils/get_purchases';
import { patch_localized_prices } from '$lib/utils/patch_localized_prices';
import { capture_supabase_error } from '$lib/utils/capture_supabase_error';
import { createSupabaseLoadClient } from '@supabase/auth-helpers-sveltekit';

// export const prerender = false;
// export const ssr = true;
export const load = async ({ fetch, data, depends }) => {
    depends('supabase:auth');

    const supabase = createSupabaseLoadClient({
        supabaseUrl: PUBLIC_SUPABASE_URL,
        supabaseKey: PUBLIC_SUPABASE_ANON_KEY,
        event: { fetch },
        serverSession: data.session
    });

    let { courses, worksheets, bundles } = data;
    let session = null;
    let school_id = null;
    let is_school_admin = false;
    let is_school_teacher = false;
    let teacher_allowed_product_ids = [];
    let user_entitlements = [];

    if (browser) {
        const { data: session_data, error: session_error } =
            await supabase.auth.getSession();
        if (session_error) {
            capture_supabase_error(session_error, {
                message: 'Layout getSession failed',
                operation: 'auth.getSession'
            });
        }

        session = session_data?.session || null;

        // Start global pricing request early (non-blocking)
        patch_localized_prices(courses, worksheets, bundles).catch((err) => {
            console.warn('patch_localized_prices throws in layout', err);
        });

        if (session) {
            const [entitlements, school_access] = await Promise.all([
                get_user_entitlements(supabase),
                get_teacher_allowed_product_ids(
                    supabase,
                    session?.user?.id || null
                )
            ]);

            school_id = school_access.school_id;
            is_school_teacher = school_access.is_school_teacher;
            is_school_admin = school_access.is_school_admin;
            teacher_allowed_product_ids = school_access.product_ids || [];
            user_entitlements = entitlements || [];

            courses = patch_purchased_courses(
                courses,
                user_entitlements,
                teacher_allowed_product_ids
            );
            worksheets = patch_purchased_worksheets(
                worksheets,
                user_entitlements,
                teacher_allowed_product_ids
            );

            bundles = patch_purchased_bundles(bundles, courses, worksheets);
        }
    }

    return {
        ...data,
        supabase,
        session,
        courses,
        worksheets,
        bundles,
        school_id,
        teacher_allowed_product_ids,
        user_entitlements,
        is_school_admin,
        is_school_teacher
    };
};
